import { useState } from 'react';
import { db } from '@/lib/db';
import type { Member } from '@/lib/db/types';
import { venmoPay } from '@/lib/venmo';
import { Sheet } from '@/components/shared/Sheet';

interface Props {
  member: Member;
  onClose: () => void;
  onSaved: (m: Member) => void;
}

export function VenmoSheet({ member, onClose, onSaved }: Props) {
  const [venmo, setVenmo] = useState(member.venmo || '');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      onSaved(await db.members.update({ venmo: venmo.trim() || null }));
      onClose();
    } finally {
      setSaving(false);
    }
  };

  const display = venmo.trim() || member.venmo;

  return (
    <Sheet title="Venmo" onClose={onClose}>
      <div className="px-4 pb-6 pt-2">
        <div className="mb-4 rounded border-l-2 border-gold bg-gold/10 px-3 py-2.5 text-[11.5px] leading-[1.5] text-ink-soft">
          Your Venmo handle is shared with club members so they can settle games off-platform. Bag Tag never processes payments.
        </div>

        <div className="mb-[18px]">
          <div className="mb-1.5 text-[10px] font-bold tracking-[0.15em] text-mute">VENMO USERNAME</div>
          <input
            value={venmo}
            onChange={(e) => setVenmo(e.target.value)}
            placeholder="@your-venmo"
            className="w-full rounded-[10px] border border-line bg-cream px-3.5 py-3 text-base text-ink outline-none"
          />
        </div>

        {display && (
          <button
            type="button"
            onClick={() => venmoPay(display)}
            className="mb-3 w-full rounded-[10px] bg-[#3D95CE] py-3.5 text-[13px] font-bold tracking-wide text-white"
          >
            Preview in Venmo
          </button>
        )}

        <div className="flex gap-2.5">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 rounded-[10px] border border-line bg-paper py-3 text-[13px] font-bold text-ink"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => void save()}
            disabled={saving}
            className="flex-[1.5] rounded-[10px] bg-navy py-3 text-[13px] font-bold text-paper disabled:opacity-50"
          >
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </Sheet>
  );
}
